import { createSlice } from '@reduxjs/toolkit'
import {
  BiddingStrategyTypes,
  ChangeAmountUnit,
  MaxBiddingAmountChangeTypes,
  Ranks,
} from 'features/Codes'

const initialState = {
  isSubmitting: false,
  strategies: [],
  errors: {},
  warnings: {},
  changeAmount: '',
  maxBiddingAmount: '',
  maxBiddingAmountChangeType: MaxBiddingAmountChangeTypes.NO_CALCULATE,
  biddingStrategyType: BiddingStrategyTypes.FIXBIDDING_BY_CUSTOM_MAX_BIDDING,
  changeAmountUnit: ChangeAmountUnit.PERCENTAGE,
  rank: Ranks.MO1,
  useRankAmount: false,
  rankAmount: '',
}

export const keywordBiddingStrategySlice = createSlice({
  name: 'dashboard/keywordBiddingStrategy',
  initialState,
  reducers: {
    reset: () => initialState,
    setStrategies: (state, { payload: strategies }) => {
      state.strategies = strategies
    },
    setBiddingAmount: (state, { payload: { id, biddingAmount } }) => {
      ;(state.strategies.find(e => e.keywordId === id) || {}).maxBiddingAmount =
        biddingAmount
    },
    setErrors: (state, { payload: errors }) => {
      state.errors = errors
    },
    setWarnings: (state, { payload: warnings }) => {
      state.warnings = warnings
    },
    setChangeAmount: (state, { payload }) => {
      state.changeAmount = payload
    },
    setMaxBiddingAmount: (state, { payload }) => {
      state.maxBiddingAmount = payload
    },
    setMaxBiddingAmountChangeType: (state, { payload }) => {
      state.maxBiddingAmountChangeType = payload
      state.maxBiddingAmount = ''
      state.changeAmount = ''
      state.rank = Ranks.MO1
      state.useRankAmount = false
      state.rankAmount = ''
    },
    setBiddingStrategyType: (state, { payload }) => {
      state.biddingStrategyType = payload
      state.maxBiddingAmountChangeType =
        MaxBiddingAmountChangeTypes.NO_CALCULATE
      state.maxBiddingAmount = ''
      state.changeAmount = ''
      state.rank = Ranks.MO1
      state.useRankAmount = false
      state.rankAmount = ''
    },
    setChangeAmountUnit: (state, { payload }) => {
      state.changeAmountUnit = payload
    },
    setRank: (state, { payload }) => {
      state.rank = payload
    },
    setUseRankAmount: (state, { payload }) => {
      state.useRankAmount = payload
    },
    setRankAmount: (state, { payload }) => {
      state.rankAmount = payload
    },
    setSubmitting: (state, { payload }) => {
      state.isSubmitting = payload
    },
  },
})

export default keywordBiddingStrategySlice.reducer
export const {
  setStrategies,
  setBiddingAmount,
  setErrors,
  setWarnings,
  reset,
  setChangeAmount,
  setMaxBiddingAmount,
  setMaxBiddingAmountChangeType,
  setBiddingStrategyType,
  setChangeAmountUnit,
  setRank,
  setUseRankAmount,
  setRankAmount,
  setSubmitting,
} = keywordBiddingStrategySlice.actions
